import React, {useEffect, useMemo, useState} from 'react';
import {useNavigate, useLocation} from "react-router-dom";
import { getLocalizedFaqData } from '../data/FaqData';
import {useTranslation} from "react-i18next";
import {getPath, getSiteLanguage} from "../utils/functions";

function FaqBannerSearchBar() {
    const [t, i18n] = useTranslation();
    const [faqHero, setFaqHero] = useState(
        "/Images/background/FAQ_bg.png"
    );

    useEffect(() => {
        const updateSize = () => {
            if (window.innerWidth < 768) {
                setFaqHero("/Images/background/FAQ_mob_bg.png");
            } else {
                setFaqHero("/Images/background/FAQ_bg.png");
            }
        };
        updateSize();
        window.addEventListener("resize", updateSize);
        return () => window.removeEventListener("resize", updateSize);
    }, []);

    const [searchQuery, setSearchQuery] = useState("");
    const navigate = useNavigate();
    const location = useLocation();
    const siteLanguage = getSiteLanguage(location.pathname);
    const localizedFaqData = useMemo(() => getLocalizedFaqData(siteLanguage), [siteLanguage]);

    // Handler for when the user presses Enter in the search input.
    const handleSearchKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault(); // Prevent any default form submission
            const query = searchQuery.trim().toLowerCase();
            if (!query) {
                return;
            }

            // Example search logic
            const results = {};
            Object.keys(localizedFaqData).forEach(section => {
                Object.keys(localizedFaqData[section]).forEach(category => {
                    const matches = localizedFaqData[section][category].filter(faq => {
                        const combinedText = (
                            section + " " + category + " " + faq.question + " " + faq.answer
                        ).toLowerCase();
                        return combinedText.includes(query);
                    });
                    if (matches.length > 0) {
                        if (!results[section]) {
                            results[section] = {};
                        }
                        results[section][category] = matches;
                    }
                });
            });

            // Example: navigate to a search results page
            navigate(getPath('/faqs/searchResult'), { state: { results, searchQuery } });
        }
    };
    return (
        <div className="faq-hero">
            <img src={faqHero} alt="FAQ Background" className="faq-hero-bg"/>
            <div className="faq-search-container">
                <i className="bi bi-search faq-search-icon"/>
                <input
                    type="text"
                    className="faq-search-input"
                    placeholder={t('faqs.placeholder')}
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    onKeyDown={handleSearchKeyDown}
                />
            </div>
        </div>
    );
}

export default FaqBannerSearchBar;
